import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ image, title, date, tags, slug }) => {
  return (
    <div className="col">
      <Link to={`/blog/${slug}`} className="text-decoration-none">
        <div className="blog-card">
          <div className="blog-card-image">
            <img loading="lazy" src={image} alt={title} />
            <div className="overlay">
              <div className="blog-logo">f</div>
              <div className="posted-by">Posted by<br />Franklin Fernandez</div>
            </div>
          </div>
          <div className="blog-card-content">
            <div className="blog-date">
              <i className="bi bi-clock me-1"></i>
              {date}
            </div>
            <h3 className="blog-title h5">{title}</h3>
            <div className="blog-tags">
              {tags.map((tag, index) => (
                <span key={index} className="badge text-bg-light">{tag}</span>
              ))}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default BlogCard;